// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
class BillingTabDialog {
    Bao = Bao;
    Dialog: BaoDialog;
    BillingId: any;
    PageIndex = ko.observable(0);
    PageSize = ko.observable(10);
    TotalRows = ko.observable(0);
    SortingVisible = ko.observable();
    SortColumnKey = ko.observable();
    Sorting = ko.observableArray([]);
    Parent: any;
    BillingPositions: KnockoutObservableArray<number> = ko.observableArray([]);
    constructor(data: any, dialog: BaoDialog) {
        this.Dialog = dialog;
        $.extend(this, data);
        this.PageIndex.subscribe((newvalue) => {
            this.RefreshSearchItems();
        });
        this.PageSize.subscribe((newvalue) => {
            if (this.PageIndex() === 0) {
                this.RefreshSearchItems();
            }
            else {
                this.PageIndex(0);
            }
        });
        this.Sorting.subscribe(() => {
            this.SearchItems();
        });
    }
    RefreshSearchItems() {
        this.Parent.TabPage.IsLoading(true);
        this.SearchItems()
            .always(() => {
            this.Parent.TabPage.IsLoading(false);
        });
    }
    SearchItems(): JQueryPromise<void> {
        return Bao.post("BillingTabDialog/GetBillingPositions", JSON.stringify({
            billingId: this.BillingId(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: this.Sorting()
        }), (result) => {
            ko.map.fromJS(result, this);
        });
    }
    public init(): JQueryPromise<void> {
        return this.SearchItems();
    }
    loaded() {
    }
}
export default BillingTabDialog;